<script setup lang="ts">
import merge from 'lodash-es/merge';
import WkArticleTopics from '#layers/prawopl/app/components/wk/ArticleTopics.vue';

defineOptions({
    name: 'WkArticlesAggregatorSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue',): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    topics: []
});

const form = computed<any>(() =>
{
    return props.modelValue;
});

watch(() => form.value.settings, () =>
{
    triggerModel();
}, { deep: true });

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

onBeforeMount((): void =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Etykietę tematyczną]]]')" :invalid-feedback="form.$errors.first('settings.topics')" :state="form.$errors.state('settings.topics')">
        <WkArticleTopics v-model="form.settings.topics" />
    </IdeoFormGroup>
</template>
